// Smart printer: tries Bluetooth ESC/POS first (if a printer is paired),
// then falls back to the OS print dialog. Used by every part of the admin
// that needs to print an order/ticket — POS, Orders list, Delivery board,
// Kitchen escalations.

import { toast } from "sonner";
import printReceipt from "@/lib/printReceipt";
import { printOrder as btPrintOrder, getState as getBtState } from "@/lib/btThermal";

/**
 * @param {object} order Full order document (items[], total, etc.)
 * @param {object} opts
 *   @param {"customer"|"kitchen"} [opts.kind="customer"]  Ticket flavor
 *   @param {58|80} [opts.width]  Roll width for dialog fallback (mm)
 *   @param {boolean} [opts.silent=false] If true, don't toast on Bluetooth fallback
 */
export async function smartPrint(order, opts = {}) {
    const {
        kind = "customer",
        width = Number(localStorage.getItem("jw_printer_width")) || 58,
        silent = false,
    } = opts;
    const bt = getBtState();
    if (bt.connected) {
        try {
            await btPrintOrder(order, { kind });
            if (!silent) toast.success("Enviado a la impresora Bluetooth");
            return { via: "bluetooth" };
        } catch (err) {
            console.warn("BT print failed, falling back to system dialog:", err);
            if (!silent) toast.error("Bluetooth falló · usando diálogo del sistema");
        }
    }
    printReceipt(order, { kind, width });
    return { via: "dialog" };
}
